import { render, staticRenderFns } from "./KoutsuhiInputForm.vue?vue&type=template&id=745c39f4&scoped=true&"
import script from "./KoutsuhiInputForm.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiInputForm.vue?vue&type=script&lang=ts&"
import style0 from "./KoutsuhiInputForm.vue?vue&type=style&index=0&id=745c39f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c39f4",
  null
  
)

export default component.exports